<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container select-modal">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{
                                $t("grade") +
                                (isUpdate
                                    ? grade.descricao
                                        ? `: ${grade.idgradeerp} - ${grade.descricao}`
                                        : `: ${grade.idgradeerp}`
                                    : grade.descricao
                                    ? `: ${grade.descricao}`
                                    : "")
                            }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("vendas")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({ name: 'ven-grade' })
                                        "
                                        >{{ $t("grades") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? $route.params.id
                                            : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $route.query.dadoscadastrais
                                    ? $router.push({
                                            name: 'ven-produto-dados-cadastrais-edit',
                                            params: { id: $route.query['id'] },
                                            query: {
                                                dadoscadastrais:
                                                    $route.query
                                                        .dadoscadastrais,
                                                politicacomercial:
                                                    $route.query
                                                        .politicacomercial,
                                                analisecomercial:
                                                    $route.query
                                                        .analisecomercial,
                                            },
                                        })
                                    : $router.push({ name: 'ven-grade' })
                            "
                        >
                            <!-- idgrade: $route.params.id, 
                                        label: $route.query.label, -->
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="
                                (!integracao &&
                                    !isUpdate &&
                                    permissao.create) ||
                                (!integracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input
                                :id="generateId(1)"
                                ref="idgradeerp"
                                v-model="grade.idgradeerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                            />
                        </div>
                        <div class="column is-9">
                            <v-input
                                :id="generateId(6)"
                                ref="descricaoInput"
                                v-model="grade.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!grade.descricao"
                                uppercase
                                title="descricao"
                                :required="true"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(2)"
                                ref="titulolinhaInput"
                                v-model="grade.titulolinha"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!grade.titulolinha"
                                uppercase
                                title="titulolinha"
                                tooltipLabel="tooltip-titulolinha"
                                tooltipPosition="is-right"
                                tooltipSize="is-small"
                                :tooltipMultilined="true"
                                :required="true"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(3)"
                                ref="titulocolunaInput"
                                v-model="grade.titulocoluna"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!grade.titulocoluna"
                                uppercase
                                title="titulocoluna"
                                tooltipLabel="tooltip-titulocoluna"
                                tooltipPosition="is-right"
                                tooltipSize="is-small"
                                :tooltipMultilined="true"
                                :required="true"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                :id="generateId(4)"
                                ref="situacaoSelect"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="!isUpdate"
                                title="situacao"
                                required
                            />
                        </div>
                    </div>
                    <div v-if="tabelaLiberada && !loadingTabela">
                        <label for="grade" v-text="$t('grade')" />
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('tela-grade-info')"
                        />
                    </div>
                </div>
                <div class="columns" v-show="isUpdate">
                    <div class="column" style="overflow-x: scroll">
                        <empty-table-message
                            v-if="!tabelaLiberada && !loadingTabela"
                            :msg="isEmpty ? 'sem-resultados' : 'grade-vazia'"
                        />
                        <loader v-if="loadingTabela" />
                        <b-table
                            v-if="tabelaLiberada && !loadingTabela"
                            :data="data"
                            :bordered="true"
                            :draggable="!integracao"
                            :draggable-column="!integracao"
                            @dragstart="dragstart"
                            @drop="drop"
                            @dragover="dragover"
                            @dragleave="dragleave"
                            @columndragstart="columndragstart"
                            @columndrop="columndrop"
                            @columndragover="columndragover"
                            @columndragleave="columndragleave"
                            class="overflow-visible"
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :width="f.width"
                                class="td-cell"
                                :sortable="f.sortable"
                            >
                                <template slot="header">
                                    <!-- 84584 - BOTÃO PARA ADICIONAR COLUNA -->
                                    <div v-if="f.new" append-to-body>
                                        <div class="field has-addons">
                                            <div class="control is-expanded">
                                                <vss-select
                                                    :id="generateId(4)"
                                                    ref="colunaSelect"
                                                    :options="colunaSelect"
                                                    v-model="colunaSelected"
                                                    :disabled="!isUpdate"
                                                    :loading="colunasLoading"
                                                    @search="loadAllColunas"
                                                    searchable
                                                    class="select-width"
                                                    placeholder="selecione"
                                                />
                                            </div>
                                            <div
                                                class="control padding-label padding-label-custom"
                                            >
                                                <b-button
                                                    @click="insertColuna"
                                                    icon-right="plus"
                                                    :disabled="
                                                        colunaSelected
                                                            ? !(
                                                                    colunaSelected.label.trim()
                                                                        .length >
                                                                    0
                                                                )
                                                            : true
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 84584 - COLUNA COM AS DESCRIÇÕES DAS LINHAS -->
                                    <div v-else-if="f.key == 'descricao'">
                                        <span>
                                            {{ $t("linha") }}
                                        </span>
                                    </div>

                                    <!-- 84584 - COLUNA PADRÃO -->
                                    <div
                                        v-else-if="f.id >= 0"
                                        class=""
                                        :class="
                                            f.situacao == 1 ? '' : 'inactivated'
                                        "
                                    >
                                        <div class="columns">
                                            <div
                                                class="column"
                                                :class="
                                                    !integracao ? 'is-9' : ''
                                                "
                                            >
                                                <span>
                                                    {{ f.key }}
                                                </span>
                                            </div>
                                            <div
                                                v-show="!integracao"
                                                class="column is-2 spacing"
                                            >
                                                <b-button
                                                    size="is-small"
                                                    @click="
                                                        promptChangeSituacao(
                                                            f,
                                                            'coluna'
                                                        )
                                                    "
                                                    class="action-button"
                                                    :type="
                                                        f['situacao'] == 1
                                                            ? 'is-danger'
                                                            : 'is-success'
                                                    "
                                                    :icon-right="
                                                        f['situacao'] == 1
                                                            ? 'delete'
                                                            : 'check'
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else>
                                        <span>
                                            {{ f.key }}
                                        </span>
                                    </div>
                                </template>

                                <template v-slot="props">
                                    <!-- 84584 - BOTÃO PARA ADICIONAR LINHA -->
                                    <div v-if="props.row[f.key] == '+'">
                                        <div class="field has-addons">
                                            <div class="control is-expanded">
                                                <vss-select
                                                    :id="generateId(4)"
                                                    ref="situacaoSelect"
                                                    :options="linhaSelect"
                                                    v-model="linhaSelected"
                                                    :disabled="!isUpdate"
                                                    :loading="linhasLoading"
                                                    @search="loadAllLinhas"
                                                    searchable
                                                    placeholder="selecione"
                                                    class="select-width"
                                                />
                                                <!-- :dropup="true" -->
                                            </div>
                                            <div
                                                class="control padding-label padding-label-custom"
                                            >
                                                <b-button
                                                    @click="insertLinha"
                                                    icon-right="plus"
                                                    :disabled="
                                                        linhaSelected
                                                            ? !(
                                                                    linhaSelected.label.trim()
                                                                        .length >
                                                                    0
                                                                )
                                                            : true
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 84584 - LINHA PADRÃO -->
                                    <div
                                        v-else-if="
                                            props.row[f.key] != '+' &&
                                            props.row[f.key]
                                        "
                                        class=""
                                        :class="
                                            props.row['situacao'] == 1
                                                ? ''
                                                : 'inactivated'
                                        "
                                    >
                                        <div class="columns">
                                            <div
                                                class="column"
                                                :class="
                                                    !integracao ? 'is-9' : ''
                                                "
                                            >
                                                <span>
                                                    {{ props.row[f.key] }}
                                                </span>
                                            </div>
                                            <div
                                                v-show="!integracao"
                                                class="column is-2 spacing"
                                            >
                                                <b-button
                                                    size="is-small"
                                                    @click="
                                                        promptChangeSituacao(
                                                            props.row,
                                                            'linha'
                                                        )
                                                    "
                                                    class="action-button"
                                                    :type="
                                                        props.row['situacao'] ==
                                                        1
                                                            ? 'is-danger'
                                                            : 'is-success'
                                                    "
                                                    :icon-right="
                                                        props.row['situacao'] ==
                                                        1
                                                            ? 'delete'
                                                            : 'check'
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else>
                                        <div>
                                            <span>
                                                {{ props.row[f.key] }}
                                            </span>
                                        </div>
                                    </div>
                                </template>
                            </b-table-column>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GradeService from "@/services/vendas/GradeService";
import GradecolunaService from "@/services/vendas/GradecolunaService";
import GradelinhaService from "@/services/vendas/GradelinhaService";
import GradeValidation from "@/services/validations/vendas/GradeValidation";
import GradeColunaLinhaValidation from "@/services/validations/vendas/GradeColunaLinhaValidation";
import Message from "@/models/Message";

export default {
    watch: {
        grade: {
            deep: true,
            handler: function () {
                if (this.flag) {
                    this.isChanged = true;
                }
            },
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.isChanged || this.linhasEdit || this.colunasEdit) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes("GRADE"),
            allIntegracoes: null,
            service: new GradeService(this.$http, this.$router),
            colunaService: new GradecolunaService(this.$http, this.$router),
            linhaService: new GradelinhaService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new GradeValidation(this.msgs),
            validationColunaLinha: new GradeColunaLinhaValidation(this.msgs),
            grade: {
                idgrade: null,
                idgradeerp: null,
                descricao: null,
                titulolinha: null,
                titulocoluna: null,
                replicapda: null,
            },
            isUpdate: false,
            situacoes: [
                { label: "inativo", id: 2 },
                { label: "ativo", id: 3 },
            ],
            situacao: { label: "ativo", id: 3 },
            isMobile: false,
            loadingTabela: false,
            tabelaLiberada: false,
            fields: [],
            data: [],
            isEmpty: false,
            showModalAssociacao: false,

            idgradecoluna: null,
            colunaSelect: [],
            colunaSelected: null,
            colunasLoading: null,

            idgradelinha: null,
            linhaSelect: [],
            linhaSelected: null,
            linhasLoading: null,
            draggingRow: null,
            draggingRowIndex: null,
            draggingColumn: null,
            draggingColumnIndex: null,

            colunasEdit: false,
            linhasEdit: false,

            isChanged: false,
            flag: false,
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-grade"
        );
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "grade" },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            } else {
                this.flag = true;
            }
        }
    },
    methods: {
        // @84584 - CRIA OS ATRIBUTOS E OS LISTENERS DE EVENTOS
        setAttributes(headers, i) {
            headers.children[i].setAttribute("draggable", true);
            headers.children[i].addEventListener("dragstart", (event) => {
                let payload = {};
                payload.event = event;
                payload.column = this.fields.filter((e) => {
                    return e.key == event.target.innerText;
                })[0];
                payload.index = event.target.cellIndex;
                this.columndragstart(payload);
            });
            headers.children[i].addEventListener("dragover", (event) => {
                let payload = {};
                payload.event = event;
                payload.column = this.fields.filter((e) => {
                    return e.key == event.target.innerText;
                })[0];
                payload.index = event.target.cellIndex;
                this.columndragover(payload);
            });
            headers.children[i].addEventListener("dragleave", (event) => {
                let payload = {};
                payload.event = event;
                payload.column = this.fields.filter((e) => {
                    return e.key == event.target.innerText;
                })[0];
                let temp = event.target;
                while (temp.nodeName != "TH") {
                    temp = temp.parentElement;
                }
                payload.index = temp.cellIndex;
                this.columndragleave(payload);
            });
            headers.children[i].addEventListener("drop", (event) => {
                let payload = {};
                payload.event = event;
                payload.column = this.fields.filter((e) => {
                    return e.key == event.target.innerText;
                })[0];
                let temp = event.target;
                while (temp.nodeName != "TH") {
                    temp = temp.parentElement;
                }
                payload.index = temp.cellIndex;
                this.columndrop(payload);
            });
        },

        // @84584 - ATRIBUI O DRAGGABLE AS COLUNAS
        setDraggable(novo = false) {
            if (this.integracao) {
                return;
            }
            let obj = document.getElementsByClassName("table")[1];
            let headers = obj.children[0].children[0];
            if (novo) {
                let i = headers.children.length - 2;
                this.setAttributes(headers, i);
            } else {
                for (let i = 1; i < headers.children.length - 1; i++) {
                    this.setAttributes(headers, i);
                }
            }
        },

        // @84584 - ATUALIZAÇÕES DE CAMPOS
        atualizaOrdem(origem) {
            let ordemInicial = [];
            if (origem == "linha") {
                for (let e of this.data) {
                    if (e.ordem) {
                        ordemInicial.push(e.ordem);
                    }
                }
                ordemInicial.sort();
                for (let i = 0; i < ordemInicial.length; i++) {
                    this.data[i].ordem = ordemInicial[i];
                }
                this.linhasEdit = true;
            } else {
                for (let f of this.fields) {
                    if (f.ordem) {
                        ordemInicial.push(f.ordem);
                    }
                }
                ordemInicial.sort();
                for (let i = 0; i < ordemInicial.length; i++) {
                    this.fields[i + 1].ordem = ordemInicial[i];
                }
                this.colunasEdit = true;
            }
        },

        // @84584 - DRAG DE LINHAS
        dragstart(payload) {
            if (payload.index == this.data.length - 1) {
                payload.event.preventDefault();
            }
            this.draggingRow = payload.row;
            this.draggingRowIndex = payload.index;
            payload.event.dataTransfer.effectAllowed = "copy";
        },
        dragover(payload) {
            if (payload.index != this.data.length - 1) {
                payload.event.dataTransfer.dropEffect = "copy";
                payload.event.target.closest("tr").classList.add("is-selected");
                payload.event.preventDefault();
            }
        },
        dragleave(payload) {
            payload.event.target.closest("tr").classList.remove("is-selected");
            payload.event.preventDefault();
        },
        drop(payload) {
            if (
                payload.index == this.data.length - 1 ||
                this.draggingRowIndex == this.data.length - 1 ||
                !this.draggingRow
            ) {
                payload.event.target
                    .closest("tr")
                    .classList.remove("is-selected");
                payload.event.preventDefault();
            } else {
                payload.event.target
                    .closest("tr")
                    .classList.remove("is-selected");
                const droppedOnRowIndex = payload.index;
                this.data.splice(this.draggingRowIndex, 1);
                this.data.splice(droppedOnRowIndex, 0, this.draggingRow);
                this.draggingRow = null;
                this.draggingRowIndex = null;
                this.draggingColumn = null;
                this.draggingColumnIndex = null;
                this.atualizaOrdem("linha");
            }
        },

        // @84584 - DRAG DE COLUNAS
        columndragstart(payload) {
            if (payload.index > 0) {
                this.draggingColumn = payload.column;
                this.draggingColumnIndex = payload.index;
                payload.event.dataTransfer.effectAllowed = "copy";
            }
        },
        columndragover(payload) {
            payload.event.dataTransfer.dropEffect = "copy";
            payload.event.target.closest("th").classList.add("is-selected");
            payload.event.preventDefault();
        },
        columndragleave(payload) {
            payload.event.target.closest("th").classList.remove("is-selected");
            payload.event.preventDefault();
        },
        columndrop(payload) {
            if (!this.draggingColumn) {
                payload.event.target
                    .closest("th")
                    .classList.remove("is-selected");
                payload.event.preventDefault();
            } else {
                payload.event.target
                    .closest("th")
                    .classList.remove("is-selected");
                const droppedOnColumnIndex = payload.index;
                this.fields.splice(this.draggingColumnIndex, 1);
                this.fields.splice(
                    droppedOnColumnIndex,
                    0,
                    this.draggingColumn
                );
                this.draggingRow = null;
                this.draggingRowIndex = null;
                this.draggingColumn = null;
                this.draggingColumnIndex = null;
                this.atualizaOrdem("coluna");
            }
        },

        criaTabela(grade) {
            this.loadingTabela = true;
            this.fields = [];
            this.fields.push({
                id: 0,
                key: "descricao",
                width: 150,
                sortable: false,
                sortFn: false,
            });
            for (let e of grade.colunas) {
                this.fields.push({
                    key: e.descricao,
                    width: 150,
                    sortable: false,
                    sortFn: false,
                    origem: "coluna",
                    situacao: e.situacao,
                    id: e.idgradecoluna,
                    idgrade: e.idgrade,
                    ordem: e.ordem,
                });
            }
            if (!this.integracao) {
                this.fields.push({
                    id: -1,
                    new: true,
                    key: "+",
                    width: 150,
                    sortable: false,
                    sortFn: false,
                });
            }
            if (grade.linhas.length == 0) {
                this.loadingTabela = false;
            }
        },
        criaData(grade) {
            this.data = [];
            for (let e of grade.linhas) {
                let linha = {};
                linha.descricao = e.descricao;
                linha.origem = "linha";
                linha.situacao = e.situacao;
                linha.id = e.idgradelinha;
                linha.idgrade = e.idgrade;
                linha.ordem = e.ordem;
                this.data.push(linha);
            }
            if (!this.integracao) {
                let novalinha = {};
                novalinha.descricao = "+";
                this.data.push(novalinha);
            }
            this.loadingTabela = false;
            this.tabelaLiberada = true;
        },
        loadAllColunas(search = ".*") {
            this.colunasLoading = true;

            this.colunaSelected = { id: 0, label: search.toLocaleUpperCase() };

            this.service
                .getAllColunas(search)
                .then((body) => {
                    this.colunaSelect = [];
                    body.content.map((e) => {
                        this.colunaSelect.push({
                            id: e.idgradecoluna,
                            label: e.descricao,
                        });
                    });
                })
                .finally((_) => {
                    this.colunasLoading = false;
                });
        },
        loadAllLinhas(search = ".*") {
            this.linhasLoading = true;

            this.linhaSelected = { id: 0, label: search.toLocaleUpperCase() };

            this.service
                .getAllLinhas(search)
                .then((body) => {
                    this.linhaSelect = [];
                    body.content.map((e) => {
                        this.linhaSelect.push({
                            id: e.idgradelinha,
                            label: e.descricao,
                        });
                    });
                })
                .finally((_) => {
                    this.linhasLoading = false;
                });
        },
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        carregarDados(id) {
            this.isUpdate = true;
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.grade = value.content;
                    this.criaTabela(this.grade);
                    this.criaData(this.grade);
                    this.situacao = this.situacoes.filter((e) => {
                        return e.id == this.grade.replicapda;
                    })[0];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.setDraggable();
                    this.isLoading = false;
                    this.flag = true;
                });
        },
        save() {
            this.grade = this.mapTosave(this.grade);
            if (this.validation.validate(this.grade, this.$refs)) {
                let flagNew = !this.isUpdate;
                this.flag = false;
                this.isChanged = false;
                let gradeTemp = Object.assign({}, this.grade);
                gradeTemp.replicapda = this.situacao.id;

                this.isSaving = true;
                this.service
                    .save(gradeTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = "grade-cadastrada-sucesso";
                            if (this.grade.idgrade != null) {
                                msg = "grade-editada-sucesso";
                            }
                            this.msgs.push(new Message("success", msg, true));
                            if (!this.isUpdate) {
                                this.redirectToEdit(value);
                            }
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        this.flag = true;
                        console.error(`Erro ao realizar ação! ${e}`);
                        this.msgs.push(
                            new Message("error", "msg-erro-load", true)
                        );
                    })
                    .then(() => {
                        if (this.colunasEdit) {
                            let colunas = [];
                            for (let i = 1; i < this.fields.length - 1; i++) {
                                let coluna = {
                                    idgradecoluna: this.fields[i].id,
                                    idgrade: this.fields[i].idgrade,
                                    descricao: this.fields[i].key,
                                    ordem: this.fields[i].ordem,
                                    situacao: this.fields[i].situacao,
                                };
                                colunas.push(coluna);
                                this.colunasEdit = false;
                            }
                            this.insertBulk(
                                this.colunaService,
                                colunas,
                                "coluna"
                            );
                        }
                        if (this.linhasEdit) {
                            let linhas = [];
                            for (let i = 0; i < this.data.length - 1; i++) {
                                let linha = {
                                    idgradelinha: this.data[i].id,
                                    idgrade: this.data[i].idgrade,
                                    descricao: this.data[i].descricao,
                                    ordem: this.data[i].ordem,
                                    situacao: this.data[i].situacao,
                                };
                                linhas.push(linha);
                            }
                            this.insertBulk(this.linhaService, linhas, "linha");
                            this.linhasEdit = false;
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        if (this.$route.query.id) {
                            this.$router.push({
                                name: "ven-produto-dados-cadastrais-edit",
                                params: { id: this.$route.query["id"] },
                                query: {
                                    idgrade: this.$route.params.id,
                                    label: this.$route.query.label,
                                    dadoscadastrais:
                                        this.$route.query.dadoscadastrais,
                                    politicacomercial:
                                        this.$route.query.politicacomercial,
                                    analisecomercial:
                                        this.$route.query.analisecomercial,
                                },
                            });
                        } else if (!flagNew) {
                            this.redirectToList();
                        }
                    });
            } else {
                this.msgs.push(
                    new Message("alert", "msg-campos-obrigatorios", true)
                );
                this.isSaving = false;
            }
        },
        insertColuna() {
            this.colunaSelected.label = this.mapTosave(this.colunaSelected.label);
            let gradecolunaDescricao = this.colunaSelected.label;
            if (this.validationColunaLinha.validate(gradecolunaDescricao)) {
                for (let f of this.fields) {
                    if (
                        f.key.toLocaleUpperCase() ==
                            gradecolunaDescricao.toLocaleUpperCase() &&
                        f.ordem
                    ) {
                        let msg = "msg-gradecoluna-duplicado";
                        return this.msgs.push(new Message("alert", msg, true));
                    }
                }

                let gradecoluna = Object.assign({});
                gradecoluna.id = 0;
                gradecoluna.key = gradecolunaDescricao;
                gradecoluna.ordem =
                    this.fields.length > 2
                        ? this.fields[this.fields.length - 2].ordem + 1
                        : 1;
                gradecoluna.idgrade = this.grade.idgrade;
                gradecoluna.origem = "coluna";
                gradecoluna.situacao = 1;
                gradecoluna.width = 150;
                gradecoluna.sortable = false;
                gradecoluna.sortFn = false;
                this.fields.splice(this.fields.length - 1, 0, gradecoluna);
                setTimeout((e) => {
                    this.setDraggable(true);
                }, 250);
                this.colunasEdit = true;
            } else {
                this.msgs.push(new Message("alert", "msg-campos-add", true));
            }
        },
        insertLinha() {
            this.linhaSelected.label = this.mapTosave(this.linhaSelected.label);
            let gradelinhaDescricao = this.linhaSelected.label;
            if (this.validationColunaLinha.validate(gradelinhaDescricao)) {
                for (let f of this.data) {
                    if (
                        f.descricao.toLocaleUpperCase() ==
                        gradelinhaDescricao.toLocaleUpperCase()
                    ) {
                        let msg = "msg-gradelinha-duplicado";
                        return this.msgs.push(new Message("alert", msg, true));
                    }
                }

                let gradelinha = Object.assign({});
                gradelinha.idgradelinha = 0;
                gradelinha.descricao = gradelinhaDescricao;
                gradelinha.ordem =
                    this.data.length > 1
                        ? this.data[this.data.length - 2].ordem + 1
                        : 1;
                gradelinha.idgrade = this.grade.idgrade;
                gradelinha.origem = "linha";
                gradelinha.situacao = 1;
                this.data.splice(this.data.length - 1, 0, gradelinha);
                this.linhasEdit = true;
            } else {
                this.msgs.push(new Message("alert", "msg-campos-add", true));
            }
        },
        insertBulk(service, objetos, origem) {
            service
                .save(objetos)
                .then((value) => {
                    if (value.message == null) {
                        let msg = `${origem}-cadastrada-sucesso`;
                        this.msgs.push(new Message("success", msg, true));
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(
                                new Message("alert", value.message, true)
                            );
                        } else {
                            this.msgs.push(
                                new Message(
                                    "error",
                                    "msg-problema-realizar-acao",
                                    true
                                )
                            );
                        }
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar ação! ${e}`);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                });
        },
        promptChangeSituacao(row) {
            row.situacao = row.situacao == 1 ? 0 : 1;
            if (row.origem == "linha") {
                this.linhasEdit = true;
            } else {
                this.colunasEdit = true;
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: "ven-grade",
                });
            }, 1000);
        },
        redirectToEdit(value) {
            setTimeout(() => {
                this.$router.push({
                    name: "ven-grade-edit",
                    params: { id: value.content.idgrade },
                });
            }, 1000);
            this.carregarDados(value.content.idgrade);
        },
        openModal(idmodal = 0, origem = "coluna") {
            if (origem == "coluna") {
                this.idgradecoluna = idmodal;
            } else {
                this.idgradelinha = idmodal;
            }
            this.showModalAssociacao = true;
        },
        fecharModal() {
            this.showModalAssociacao = false;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    this.linhasEdit = false;
                    this.colunasEdit = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
    },
};
</script>
<style lang="scss">
.overflow-visible .table-wrapper {
    overflow-x: visible !important;
}
.th-wrap span {
    width: 100%;
}
.b-table .table th .th-wrap .icon {
    margin-left: 0;
    width: 5px;
}
</style>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }

    .block-with-text {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    .inactivated {
        font-weight: bolder;
        color: red;
    }

    .spacing {
        margin-right: 1.5rem;
        padding-left: 0;
    }
}
.padding-label-custom {
    padding-top: 0;
}
.select-width {
    min-width: 70px;
}
</style>
